import React, { useState } from 'react'
import AInvbasicDetail from './AInvbasicDetail'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { addInvoiceApi } from '../apiService'
import { globalPostService } from '../../../utils/globalApiServices'
import { checkApiStatus, normalizeTaxRate } from '../../../utils'
import { useSnackbar } from 'notistack'
import { PageLoader, titanAviationIntance, hanwahaInstance } from '../../../shared_elements'
import moment from 'moment'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import { setFileUploadDetails, setUploadFiles } from '../../../shared_elements/actions'
import { trackActivity } from '../../../utils/mixpanel'
import { getInvoiceDialogWidthProps } from './AInvItems'

const AddFleetInvoice = ({onToggleModal, modeType, addEditInvoice, getResponseBack,fileUpload}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [invoice, setInvoice] = useState(addEditInvoice?.data);
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState({});
  const [tableErrors, setTableErrors] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isQbEnabled, setIsQbEnabled] = useState(false);
  const showQbValidation = isQbEnabled && hanwahaInstance;

    const onAddEditInvoice = () => {
        let validationInputs = {
            invoice_number: invoice?.invoice_number?.trim()?.length ? '' : 'Please enter Invoice Number',
            date: invoice?.date ? '' : 'Please enter Invoice Date',
            due_date: invoice?.due_date ? '' : 'Please enter Invoice Due Date',
            start_date: invoice?.start_date ? '' : 'Please enter Period Start Date',
			end_date: invoice?.end_date ? '' : 'Please enter Period End Date',
            currency: invoice?.currency ? '' : 'Please select Currency',
            bank: invoice?.bank?.id ? '' : 'Please select Bank',
            from: invoice?.from?.id ? '' : 'Please select FROM',
            to: invoice?.to?.id ? '' : 'Please select TO'
        }

        const invoiceDate = moment(invoice?.date);
        const dueDate = moment(invoice?.due_date);
        const startDate = moment(invoice?.start_date);
        const endDate = moment(invoice?.end_date);

        if (invoice?.date && invoice?.end_date) {
            const endDate = moment(invoice?.end_date);
            if (invoiceDate.isBefore(endDate)) {
                validationInputs.date = "Invoice Date cannot be before Period End Date";
            }
        }

        if (invoice?.date && invoice?.due_date) {
            if (dueDate.isBefore(invoiceDate)) {
                validationInputs.due_date = "Due Date cannot be before Invoice Date";
            }
            if (invoiceDate.isAfter(dueDate)) {
                validationInputs.date = "Invoice Date cannot be after Due Date";
            }
            if (invoice?.due_date && !dueDate.isValid()) {
                validationInputs.due_date = "Please enter valid Due Date";
            }
            if (invoice?.date &&!invoiceDate.isValid()) {
                validationInputs.date = "Please enter valid Invoice Date";
            }
        }

        if (invoice?.start_date && startDate.isValid() && startDate.isAfter(moment(), 'day')) {
            validationInputs.start_date = "Period Start Date cannot be a future date";
        }
        if (invoice?.start_date && invoice?.end_date) {
			if (endDate.isBefore(startDate)) {
				validationInputs.end_date = "Period End Date cannot be before Period Start Date";
			}
			if (startDate.isAfter(endDate)) {
				validationInputs.start_date = "Period Start Date cannot be after Period End Date";
			}
			if (invoice?.end_date && !endDate.isValid()) {
                validationInputs.end_date = "Please enter valid Period End Date";
            }
            if (invoice?.start_date &&!startDate.isValid()) {
                validationInputs.start_date = "Please enter valid Period Start Date";
            }
		}
        setError({ ...validationInputs });

        // ----------------Item Table Condition-----------
        if (
            invoice?.due_date &&
            invoice?.date &&
            invoice?.invoice_number &&
            invoice?.currency &&
            invoice?.bank &&
            invoice?.from &&
            invoice?.to &&
            !dueDate.isBefore(invoiceDate) &&
            invoice?.invoice_items?.length === 0
        ) {
            enqueueSnackbar(
                'Please add at least one Invoice Item',
                {
                    variant: "error",
                    anchorOrigin: { horizontal: "right", vertical: "top" },
                }
            );
            return;
        }

        let newErrors = {};

        invoice.invoice_items.forEach((row, index) => {
            const errors = {};

            if (!row.invoice_item_name) {
                errors.invoice_item_name = "Please enter Invoice Item";
            }

            if ((!titanAviationIntance || invoice?.invoice_type?.value === 9) && !row.description?.trim()) {
                errors.description = "Please enter Description";
            }

            if (row.sub_total === "" || row.sub_total === null || row.sub_total === undefined) {
                errors.sub_total = "Please enter Amount.";
            } else if (Number(row.sub_total) <= 0) {
                errors.sub_total = "Please enter an Amount greater than 0.";
            }

            if (showQbValidation && !row.qb_product_and_service_id) {
                errors.qb_product_and_service_id = "Please select Product & Service";
            }

            if (showQbValidation && !row.qb_chart_of_account_id) {
                errors.qb_chart_of_account_id = "Please select Chart of Account";
            }

            if (showQbValidation && !row.qb_class_id) {
                errors.qb_class_id = "Please select Class";
            }

            if (showQbValidation && !row.qb_sub_class_id) {
                errors.qb_sub_class_id = "Please select Sub Class";
            }

            if (Object.keys(errors).length > 0) {
                newErrors[index] = errors;
            }
        });

            setTableErrors(newErrors)
        if (!Object.keys(validationInputs).every((k) => validationInputs[k] === '') || Object.keys(newErrors).length > 0) {
            trackActivity(`Item Added`, { page_title: addEditInvoice.type === 'adhoc' ? 'Add Adhoc Invoice' : addEditInvoice.type === 'credit' ? 'Add Credit Invoice' : 'Add Debit Invoice', error_msg: validationInputs, })
            return;
        }
        setLoading(true);
        const payload = {
            ...invoice,
            footer_note : invoice?.bank?.footer_note || null,
            invoice_items: invoice.invoice_items.map(({ qb_product_and_service_id, qb_chart_of_account_id, qb_class_id, qb_sub_class_id, ...item }) => ({
                ...item,
                tax_rate: normalizeTaxRate(item?.tax_rate),
                qb_product_and_service: qb_product_and_service_id || null,
                qb_chart_of_account: qb_chart_of_account_id || null,
                qb_class: qb_class_id || null,
                qb_sub_class: qb_sub_class_id || null,
            })),
        };
        globalPostService(addInvoiceApi(), payload)
            .then(async(response) => {
                if (checkApiStatus(response)) {
                    if (attachments?.length) {
                        dispatch(setUploadFiles({ modal:true,slug: response?.data?.data?.slug }));
                    }
                    setLoading(false);
                    onToggleModal()
                    trackActivity('Item Added', { page_title: addEditInvoice.type === 'adhoc' ? 'Add Adhoc Invoice' : addEditInvoice.type === 'credit' ? 'Add Credit Invoice' : 'Add Debit Invoice', success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: invoice, response: response?.data })
                    navigate(`/invoices/view/${response?.data?.data?.slug}`)
                    getResponseBack();
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    trackActivity('Item Added', { page_title: addEditInvoice.type === 'adhoc' ? 'Add Adhoc Invoice' : addEditInvoice.type === 'credit' ? 'Add Credit Invoice' : 'Add Debit Invoice', error_msg: response?.data?.message, item_id: null, payload: invoice, response: response?.data })
                }
            })
    };

    const onFieldChange = (keyParam, value, invoiceItem, itemIndex) => {
        if (invoiceItem) {
            if (keyParam === "sub_total" || keyParam === "tax_rate") {
                let taxAmount = 0;
                let subTotal = 0;

                if (keyParam === "sub_total") {
                    subTotal = parseFloat(value) || 0;
                    if (invoice.invoice_items[itemIndex].tax_rate) {
                        taxAmount = subTotal * (parseFloat(invoice.invoice_items[itemIndex].tax_rate) / 100);
                    }
                } else {
                    subTotal = parseFloat(invoice.invoice_items[itemIndex].sub_total) || 0;
                    if (value) {
                        taxAmount = subTotal * (parseFloat(value) / 100);
                    }
                }

                const subAmountTotal = subTotal + taxAmount;

                setInvoice({
                    ...invoice,
                    invoice_items: invoice.invoice_items.map((item, index) =>
                        index !== itemIndex
                            ? item
                            : {
                                ...item,
                                [keyParam]: value,
                                tax_amount: taxAmount.toFixed(4),
                                sub_amount_total: subAmountTotal.toFixed(4),
                            }
                    ),
                });
            } else {
                setInvoice({
                    ...invoice,
                    invoice_items: invoice.invoice_items.map((item, index) =>
                        index !== itemIndex ? item : { ...item, [keyParam]: value, ...(keyParam === 'qb_class_id' ? { qb_sub_class_id: null } : {}) }
                    ),
                });
            }
        } else {
            if (keyParam === 'asset') {
                if (value) {
                    const assetLessor = value.lessor_list?.[0] || null;
                    const assetLessee = value.lessees?.[0] || null;
                    setInvoice({ ...invoice, [keyParam]: value, ['from']: assetLessor, ['to']: assetLessee, bank: null });
                    setError(prev => ({
                        ...prev,
                        ...(assetLessor ? { from: '' } : {}),
                        ...(assetLessee ? { to: '' } : {}),
                    }));
                } else {
                    setInvoice({ ...invoice, [keyParam]: value, ['from']: null, ['to']: null, bank: null });
                }
            } else {
                if (keyParam === 'from') {
                    setInvoice({ ...invoice, from: value, bank: null });
                } else {
                    setInvoice({ ...invoice, [keyParam]: value });
                }

            }
        }
    };

    const onAddRemoveInvoiceItem = (opsType, itemIndex) => {
        if(opsType === 'add'){
            setInvoice({
                ...invoice,
                invoice_items:[...invoice.invoice_items, {invoice_item_name:'',description:'',tax_rate:0, tax_amount:'', sub_total:0}]
            })
        }else{
            setInvoice({
                ...invoice,
                invoice_items: invoice.invoice_items.filter((item, index) => itemIndex !== index)
            })
        }
    }

    const onRestErrorKey = (keyParam) => {
        setError(prev => ({ ...prev, [keyParam]: '' }))
    }

    

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({attachments:files}))
    };

    const resetTableError = (rowIndex, fieldName) => {
        setTableErrors((prevErrors) => {
            const rowErrors = { ...prevErrors[rowIndex] };
            delete rowErrors[fieldName];

            const updatedErrors = { ...prevErrors };
            if (Object.keys(rowErrors).length === 0) {
                delete updatedErrors[rowIndex];
            } else {
                updatedErrors[rowIndex] = rowErrors;
            }

            return updatedErrors;
        });
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title:addEditInvoice.type === 'adhoc' ? 'Add Adhoc Invoice' : addEditInvoice.type === 'credit' ? 'Add Credit Invoice' : 'Add Debit Invoice', page_type: page_type, })
    }
    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                {...getInvoiceDialogWidthProps({ invoice, type: 'fleetInvoice', showQbFields: showQbValidation })}
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2, pl:3 }} className='dialog-header' id="customized-dialog-title">
                    {addEditInvoice.type === 'adhoc' ? 'Add Adhoc Invoice' : addEditInvoice.type === 'credit' ? 'Add Credit Invoice' : 'Add Debit Invoice'} 
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <AInvbasicDetail addEditInvoice={addEditInvoice} type={'fleetInvoice'} modeType={modeType} onFieldChange={onFieldChange} onRestErrorKey={onRestErrorKey} invoice={invoice} error={error} onAddRemoveInvoiceItem={onAddRemoveInvoiceItem} handleFileChange={handleFileChange} tableErrors={tableErrors} resetTableError={resetTableError} onQbStatusLoad={setIsQbEnabled}/>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' variant='outlined' size='small'
                        onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}
                    > Cancel </Button>
                    <Button variant='contained' className='btn-primary' size='small' onClick={() => { handleItemClicked('Save Button'); onAddEditInvoice() }}>
                        {isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}

export default AddFleetInvoice